// import type { ProductData } from '@/lib/cms/types/getProductData'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { HydraGetSubscriptionItem } from './getSubscriptions'

type Props = {
  hydraToken: string
  href: string
}
export type HydraGetSubscriptionsResponse = {
  item: HydraGetSubscriptionItem
}

export const HydraGetSubscription = ({ hydraToken, href }: Props) => {
  const request: SendRequestType = {
    method: 'GET',
    url: href,
    token: hydraToken,
    baseURL: 'internal',
  }

  return httpTools.sendRequest<HydraGetSubscriptionItem>(request)
}
